import { z } from "zod"
import { emailSchema } from "../common/email-validator"
import { phoneNumberSchema } from "../common/phone-number-validator"
import { nullableToOptional } from "../common/zod-utils"
import { TranslationKey } from "../i18n/translation-key"

export const CustomerContactDetailsSchema = z.object({
  firstName: z
    .string()
    .min(1, "common.validation.firstNameRequired" satisfies TranslationKey),
  lastName: z.string().nullable(),
  phoneNumber: phoneNumberSchema(),
  email: emailSchema().nullable(),
})

export type CustomerContactDetails = z.infer<
  typeof CustomerContactDetailsSchema
>

export const SaveCustomerContactDetailsSchema = nullableToOptional(
  CustomerContactDetailsSchema,
)

export type SaveCustomerContactDetails = z.infer<
  typeof SaveCustomerContactDetailsSchema
>

export interface CustomerContactDetailsSearchFilters {
  firstName?: string
  lastName?: string
  phoneNumber?: string
  email?: string
}

export interface CustomerClubMembership {
  isMember: boolean
}

/**
 * Identifies a customer within a store: the last 9 digits of the phone
 * number, so "070…" and "+4670…" resolve to the same customer.
 */
export const toPhoneKey = (phoneNumber: string): string =>
  phoneNumber.replace(/\D/g, "").slice(-9)
